/** Nur Lots/Achats/Ventes — Produktkatalog allein löst keine Stock-Berechnungsanzeige aus. */
export function calculateStockMovementHash(lots, purchases, sales) {
  const lotsList = Array.isArray(lots)
    ? lots
    : Object.values(lots || {});

  const dataString = JSON.stringify({
    lots: lotsList.map((l) => ({
      id: l.id,
      updatedAt: l.updatedAt,
      remainingQuantity: l.remainingQuantity
    })),
    purchases: (purchases || []).map((p) => ({
      id: p.id,
      updatedAt: p.updatedAt,
      createdAt: p.createdAt
    })),
    sales: (sales || []).map((s) => ({
      id: s.id,
      updatedAt: s.updatedAt,
      createdAt: s.createdAt
    }))
  });

  let hash = 0;
  for (let i = 0; i < dataString.length; i += 1) {
    const char = dataString.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash &= hash;
  }
  return hash.toString();
}

/** Fingerprint for inventory-relevant entity changes. */
export function calculateInventoryDataHash(products, lots, purchases, sales) {
  const lotsList = Array.isArray(lots)
    ? lots
    : Object.values(lots || {});

  const dataString = JSON.stringify({
    products: (products || []).map((p) => ({
      id: p.id,
      updatedAt: p.updatedAt,
      createdAt: p.createdAt
    })),
    lots: lotsList.map((l) => ({
      id: l.id,
      updatedAt: l.updatedAt,
      remainingQuantity: l.remainingQuantity
    })),
    purchases: (purchases || []).map((p) => ({
      id: p.id,
      updatedAt: p.updatedAt,
      createdAt: p.createdAt
    })),
    sales: (sales || []).map((s) => ({
      id: s.id,
      updatedAt: s.updatedAt,
      createdAt: s.createdAt
    }))
  });

  let hash = 0;
  for (let i = 0; i < dataString.length; i += 1) {
    const char = dataString.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash &= hash;
  }
  return hash.toString();
}
